module.exports = __webpack_public_path__ + "img/wulianwang.png";